<template>
  <div class="faqThemeCardList flex flex-col items-center">
    <div class="w-full">
      <Heading
        :content="title"
        tag="h2"
        :align="align"
        role="headline"
        size="large"
        class="mb-8"
      />
    </div>

    <div
      class="faqThemeCardList__grid flex flex-col flex-wrap justify-center md:flex-row w-full"
      :class="{ 'last:col-span-2 last:justify-self-center': isOddNumber }"
    >
      <FaqThemeCard
        v-for="(card, index) in visibleCards"
        :key="card.title + index"
        :title="card.title"
        :faq-items="card.faqItems"
        :centered="card.centered"
        :redirect-url="card.redirectUrl"
        :space-bottom="card.spaceBottom"
        :class="{
          'col-span-2 justify-self-center':
            isOddNumber && index === visibleCards.length - 1,
        }"
        :icon="card.icon"
      />
    </div>

    <div v-if="hasMoreCards" class="faqThemeCardList__actions mt-8 text-center">
      <BasicButton
        button-type="outlined"
        aria-label="Mehr Themenkarten anzeigen"
        @click="toggleShowMore"
      >
        {{ showAllCards ? 'Weniger zeigen' : 'Mehr Themenkarten anzeigen' }}
      </BasicButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import './FaqThemeCardList.scss';
import { ref, computed } from 'vue';
import Heading, { type HeadingProps } from 'ewi-ui/components/1-atoms/Heading';
import FaqThemeCard, {
  type FaqThemeCardProps,
} from 'ewi-ui/components/2-molecules/FaqThemeCard';
import BasicButton from 'ewi-ui/components/1-atoms/BasicButton/BasicButton.vue';

export interface FaqThemeCardListProps {
  title: string;
  cards: FaqThemeCardProps[];
  align?: HeadingProps['align'];
}

const props = withDefaults(defineProps<FaqThemeCardListProps>(), {
  title: 'FAQ Themenbereiche',
  cards: () => [],
  align: 'center',
});

const showAllCards = ref(false);

const hasMoreCards = computed(() => props.cards.length > 2);

const visibleCards = computed(() => {
  if (showAllCards.value || !hasMoreCards.value) {
    return props.cards;
  }
  return props.cards.slice(0, 2);
});

const isOddNumber = computed(() => visibleCards.value.length % 2 !== 0);

const toggleShowMore = () => {
  showAllCards.value = !showAllCards.value;
};
</script>
